import React, { useState } from "react";
const BASE_API = process.env.BASE_API_URL || "https://scanmymenu-nm38.onrender.com/api";

export default function AdminSignup() {

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("client");

  const [message, setMessage] = useState("");

  const handleSignup = async (e) => {
    e.preventDefault();

    try {

      const response = await fetch(
         `${BASE_API}/admin/signup`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            username,
            email,
            password,
            role
          })
        }
      );

      const data = await response.json();

      if (data.success) {

        setMessage("Signup successful ✅");

        setTimeout(() => {
          window.location.href =
            "/admin-login";
        }, 1500);

      } else {

        setMessage(data.message);

      }

    } catch (error) {

      setMessage("Signup failed");

    }

  };

  return (

    <div style={styles.container}>

      <form
        onSubmit={handleSignup}
        style={styles.form}
      >

        <h2 style={styles.title}>
          Admin Signup
        </h2>

        <input
          type="text"
          placeholder="Username"
          required
          value={username}
          onChange={(e) =>
            setUsername(e.target.value)
          }
          style={styles.input}
        />

        <input
          type="email"
          placeholder="Email"
          required
          value={email}
          onChange={(e) =>
            setEmail(e.target.value)
          }
          style={styles.input}
        />

        <input
          type="password"
          placeholder="Password"
          required
          value={password}
          onChange={(e) =>
            setPassword(e.target.value)
          }
          style={styles.input}
        />

        <select
          value={role}
          onChange={(e) =>
            setRole(e.target.value)
          }
          style={styles.input}
        >

          <option value="client">
            Client
          </option>

          <option value="admin">
            Admin
          </option>

        </select>

        <button style={styles.button}>
          Signup
        </button>

        {message && (
          <p style={styles.message}>
            {message}
          </p>
        )}

      </form>

    </div>

  );

}
const styles = {

  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    minHeight: "100vh",

    padding: "20px",

    background:
      "linear-gradient(135deg,#1e3c72,#2a5298)",

    fontFamily:
      "Segoe UI, Tahoma, Geneva, Verdana, sans-serif"
  },

  form: {
    width: "100%",
    maxWidth: "380px",

    padding: "32px",

    background: "#ffffff",

    borderRadius: "16px",

    boxShadow:
      "0 10px 30px rgba(0,0,0,0.2)",

    display: "flex",
    flexDirection: "column"
  },

  title: {
    textAlign: "center",

    marginBottom: "22px",

    fontSize: "26px",

    fontWeight: "600",

    color: "#1e3c72"
  },

  input: {
    width: "100%",

    padding: "13px",

    marginBottom: "16px",

    borderRadius: "10px",

    border: "1px solid #ddd",

    fontSize: "15px",

    outline: "none",

    transition: "0.2s",

    background: "#fafafa",

    boxSizing: "border-box"
  },

  button: {
    width: "100%",

    padding: "14px",

    background:
      "linear-gradient(90deg,#1e3c72,#2a5298)",

    color: "#fff",

    border: "none",

    borderRadius: "10px",

    fontSize: "16px",

    fontWeight: "600",

    cursor: "pointer",

    marginTop: "4px",

    boxShadow:
      "0 4px 12px rgba(30,60,114,0.4)"
  },

  message: {
    textAlign: "center",

    marginTop: "12px",

    fontSize: "14px",

    fontWeight: "500",

    color: "red"
  }

};